import * as React from 'react'
import * as classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'

import * as Style from './style.css'

import PcQaArrowDown from './pc_qa_arrow_down.svg?reactCompornt'
import PcQaArrowUp from './pc_qa_arrow_up.svg?reactCompornt'
import SpQaArrowDown from './sp_qa_arrow_down.svg?reactCompornt'
import SpQaArrowUp from './sp_qa_arrow_up.svg?reactCompornt'

import PcQaIcon from './pc_qa.png'
import SpQaIcon from './sp_qa.png'

export interface IProps {
  question: string
  answer: React.ReactNode
  answerNote?: React.ReactNode
  accordionOpen: boolean
  accordionClickHandler: () => void
}

export const ContentEpisodeFaqRow = ({
  question,
  answer,
  answerNote,
  accordionOpen,
  accordionClickHandler,
  ...props
}: IProps): JSX.Element => {
  return (
    <div className={Style.ContentEpisodeFaqRow}>
      <div className={Style.ContentEpisodeFaqRowShadow}>
        <button
          className={Style.ContentEpisodeFaqQuestion}
          onClick={accordionClickHandler}
        >
          <div className={Style.ContentEpisodeFaqQuestionLabel}>
            <img
              src={PcQaIcon}
              className={classNames(
                Style.ContentEpisodeFaqQuestionIcon,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={SpQaIcon}
              className={classNames(
                Style.ContentEpisodeFaqQuestionIcon,
                Style.SpOnly,
              )}
            />
            {question}
          </div>
          {!accordionOpen && (
            <>
              <PcQaArrowDown
                className={classNames(
                  Style.ContentEpisodeFaqRowArrow,
                  Style.TabletPcOnly,
                )}
              />
              <SpQaArrowDown
                className={classNames(
                  Style.ContentEpisodeFaqRowArrow,
                  Style.SpOnly,
                )}
              />
            </>
          )}
          {accordionOpen && (
            <>
              <PcQaArrowUp
                className={classNames(
                  Style.ContentEpisodeFaqRowArrow,
                  Style.TabletPcOnly,
                )}
              />
              <SpQaArrowUp
                className={classNames(
                  Style.ContentEpisodeFaqRowArrow,
                  Style.SpOnly,
                )}
              />
            </>
          )}
        </button>
        <AnimatePresence>
          {accordionOpen && (
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: 'auto' }}
              exit={{ height: 0 }}
              transition={{ duration: 0.3 }}
              style={{ overflow: 'hidden' }}
            >
              <div className={Style.ContentEpisodeFaqRowBorder}>
                <div className={Style.ContentEpisodeFaqRowAnswer}>
                  <div className={Style.ContentEpisodeFaqRowAnswerText}>
                    {answer}
                  </div>
                  {answerNote && (
                    <div className={Style.ContentEpisodeFaqRowAnswerNote}>
                      {answerNote}
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  )
}
